import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { APP_VALIDATION_REGEX, UI_MESSAGES } from 'src/app/app.contant';
import { AgGridWrapperComponent } from 'src/app/modules/shared/components/ag-grid-wrapper/ag-grid-wrapper.component';
import { PrBuyerDashboardService } from '../../../services/pr-buyer-dashboard.service';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';

@Component({
  selector: 'app-add-vendors',
  templateUrl: './add-vendors.component.html',
  styleUrls: ['./add-vendors.component.scss']
})
export class AddVendorsComponent implements OnInit {
  public title !: string;
  public searchVendorForm !: FormGroup;
  public vendorList !: any;

  public vendorResults !: any;
  public prID!: any;

  public onClose = new Subject<any>();

  @ViewChild('grid') grid!: AgGridWrapperComponent;
  public gridApi: any;
  public gridColumnApi: any;

  public frameworkComponents: any;
  public context: any;

  public gridOptions: GridOptions = {
    defaultColDef: {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 200,
      filter: true,
      resizable: true,
      autoHeight: true,
      wrapText: true
    },
    suppressContextMenu: false,
    suppressMenuHide: false,
    sideBar: "true",
    rowGroupPanelShow: 'always',
    headerHeight: 40,
    pagination: true,
    paginationPageSize: 25,
    rowSelection: 'multiple',
    suppressCellSelection: true,
    overlayNoRowsTemplate: 'No results found.'
  };
  public columnDefs: (ColDef | ColGroupDef)[] = [];
  public lineitem_list!: any[];
  lineitemNumber: any = "";

  constructor(private _formBuilder: FormBuilder,
    private _buyerService: PrBuyerDashboardService,
    private _buyerHelperService: PrBuyerHelperService,
    private _toastrService: ToastrService,
    public bsModalRef: BsModalRef) {
    this.searchVendorForm = this._formBuilder.group({
      // line_item_number: [null, [Validators.required]],
      vendor_code: [null, [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['NO_SPECIAL_CHARACTERS'])]]
    });
   }

  ngOnInit(): void {
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: any) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public fetchVendordata(): void {
    const vendorCode = this.searchVendorForm.controls['vendor_code'].value
    const modifiedVCode = vendorCode;
    if (this.vendorList.includes(modifiedVCode)) {
      this._toastrService.error("This vendor already added. Please try new vendor code",'')
    } else {
      this._buyerService.fetchVendorResults(this.searchVendorForm.getRawValue().vendor_code, this.prID).subscribe((res: any) => {
        if (res.status == 200 && res.data?.length) {
          this.columnDefs = this._buyerHelperService.getvendorResultsColumnDefs();
          this.vendorResults = res.data;
          this._toastrService.success(res.message);
        } else {
          this._toastrService.success(UI_MESSAGES.NO_DATA);
        }
      });
    }
  }

public validateVendor() {
  const selectedRows: Array<any> = this.grid.getSelectedData();
  if(selectedRows[0].Mail_Address) {
    this.addVendorToLineitem(selectedRows[0]);
  } else {
    const emailModal$ = this._buyerHelperService.openAddEmailForVendorModal(this.prID, selectedRows[0], this.lineitem_list);
    if(emailModal$) {
      emailModal$.subscribe((response : any) => {
        if(Object.keys(response)?.length) {
          this.addVendorToLineitem(response);
        }
      });
    }
  }
}

private addVendorToLineitem(vendor: any) {
  this._buyerService.addVendorToLineitem(vendor.selectedVendor).subscribe((res: any) => {
    this._toastrService.success(res.message);
    this.closeModal({marketResult : vendor, lineItemNumber : vendor.lineItemList});
  }, (err: any) => {
    this._toastrService.error(err.error.message || UI_MESSAGES.GENERIC_ERROR);
    this.onModalClose();
  });
}

public onGridReady() {
  this.grid.autoSizeAll(false);
}

}
